import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { Images, MessageCircle } from 'lucide-react';
import { openWhatsApp } from '../utils/whatsapp';
export function Environment() {
  return <section className="py-24 bg-sand" data-id="element-74">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-75">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-76">
          {/* Video vertical a la izquierda */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="w-full lg:w-5/12 relative" data-id="element-77">
            <div className="aspect-[9/16] rounded-2xl overflow-hidden shadow-2xl bg-black relative z-10" data-id="element-78">
              <video autoPlay loop muted playsInline poster="https://cdn.magicpatterns.com/uploads/vfv5F97i4iN6dLC2Kyw5Wd/VISTA_DRON_EL_MIRADOR.png" className="w-full h-full block object-cover" data-id="element-79">
                <source src="https://cdn.magicpatterns.com/uploads/mTs5SiRpnFVBG5Tycb4Xhw/VIDEO DE EL MIRADOR VISTA DROM.mp4" type="video/mp4" data-id="element-80" />
              </video>
            </div>
            {/* Elemento decorativo de fondo */}
            <div className="absolute -bottom-6 -left-6 w-2/3 h-2/3 bg-olive/10 rounded-2xl -z-10" data-id="element-81"></div>
          </motion.div>

          {/* Texto y botones a la derecha */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="w-full lg:w-7/12 text-center lg:text-left" data-id="element-82">
            <h2 className="text-4xl md:text-5xl text-olive-dark font-serif mb-6 leading-tight" data-id="element-83">
              Naturaleza, calma y una vista inolvidable
            </h2>

            <p className="text-lg md:text-xl text-charcoal-light leading-relaxed mb-10" data-id="element-84">
              Todo el complejo está rodeado de naturaleza y ofrece una hermosa
              vista del valle, creando el ambiente ideal para descansar,
              desconectarse de la rutina y disfrutar del aire puro de las
              sierras. Un lugar pensado para vivir momentos simples, tranquilos
              y memorables.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4" data-id="element-85">
              <a href="#galeria" className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-olive text-white rounded-full font-medium hover:bg-olive-dark transition-colors shadow-lg w-full sm:w-auto" data-id="element-86">
                <Images size={20} data-id="element-87" />
                Ver galería
              </a>
              <button onClick={() => openWhatsApp()} className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-transparent border border-olive text-olive rounded-full font-medium hover:bg-olive hover:text-white transition-colors w-full sm:w-auto" data-id="element-88">
                <MessageCircle size={20} data-id="element-89" />
                Consultanos
              </button>
              <a href="https://www.instagram.com/cabanas_mirador/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-transparent border border-olive text-olive rounded-full font-medium hover:bg-olive hover:text-white transition-colors w-full sm:w-auto" data-id="element-90">
                Nuestras promociones
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}